import React, { useState, useEffect } from 'react';
import Spinner from '../../components/Spinner';
import QuarterlyPerformance from './components/QuarterlyPerformance';
import ChainSplit from './components/ChainSplit';
import AssetBreakdown from './components/AssetBreakdown';
import {
  getQuarterlyPerformance,
  exchangeOverviewSelector,
  getExchangePerformanceSummary,
  getExchangeAssetInfo,
} from '../../store/exchanges/overview';
import { batch, useDispatch, useSelector } from 'react-redux';
import SpotOverview from './components/SpotOverview';

const Exchange = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {
    quarterly_performance,
    performance_summary,
    available_exchange_providers,
    balance_breakdown,
    exchange_asset_breakdown,
    exchange_split,
    future_asset_overview,
    overall_asset_breakdown,
    spot_asset_overview,
  } = useSelector(exchangeOverviewSelector);
  const [quarterlyPerformance, setQuarterlyPerformance] = useState();
  const [performanceSummary, setPerformanceSummary] = useState();

  useEffect(() => {
    batch(() => {
      dispatch(getExchangeAssetInfo());
      dispatch(getQuarterlyPerformance());
      dispatch(getExchangePerformanceSummary());
    });
  }, [dispatch]);

  useEffect(() => {
    setQuarterlyPerformance(quarterly_performance);
    setPerformanceSummary(performance_summary);
  }, [quarterly_performance, performance_summary]);

  useEffect(() => {
    setLoading(true);

    let timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="custom_dashboard">
          <div style={{ width: '100%', display: 'flex' }}>
            <div style={{ width: '66.66%' }}>
              <div className="" style={{ width: '100%' }}>
                <QuarterlyPerformance
                  data={quarterlyPerformance}
                  performance_summary={performanceSummary}
                />
              </div>
            </div>
            <div className="slds-col slds-size_4-of-12">
              <SpotOverview chain_total_amounts={spot_asset_overview} title="Total Spot Overview" />
            </div>
          </div>

          <div>
            <div style={{ width: '100%', display: 'flex' }}>
              <div
                style={{
                  flex: '1 1 0',
                  width: 0,
                }}
              >
                <ChainSplit
                  chain_total_amounts={future_asset_overview}
                  title="Future Assets Breakdown"
                />
              </div>

              <div
                style={{
                  flex: '1 1 0',
                  width: 0,
                }}
              >
                <ChainSplit
                  chain_total_amounts={overall_asset_breakdown}
                  title="Overall Assets Breakdown"
                />
              </div>

              <div
                style={{
                  flex: '1 1 0',
                  width: 0,
                }}
              >
                <ChainSplit chain_total_amounts={balance_breakdown} title="Balance Breakdown" />
              </div>
            </div>

            <div style={{ width: '100%', display: 'flex' }}>
              <div style={{ width: '66.66%' }}>
                <AssetBreakdown
                  chain_asset_breakdown={exchange_asset_breakdown}
                  available_chains={available_exchange_providers}
                  title="Exchange Asset Breakdown"
                />
              </div>
              <div style={{ width: '33.33%', marginTop: '0.6rem' }}>
                <ChainSplit chain_total_amounts={exchange_split} title="Exchange Split" />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Exchange;
